
const AnalysisServices = () => {
  const analysisServices = [
    {
      title: "Scale Analysis & Characterization",
      description: "Comprehensive analysis of scale deposits to determine composition, formation mechanisms, and optimal removal strategies.",
      icon: "ri-microscope-line",
      image: "https://public.readdy.ai/ai/img_res/899bd519c16fc97d3eadccfd3a967bfe.jpg",
      capabilities: [
        "XRD crystalline structure analysis",
        "SEM morphology examination",
        "Chemical composition determination",
        "Scale formation kinetics study"
      ]
    },
    {
      title: "Corrosion Assessment",
      description: "Advanced corrosion analysis and monitoring to protect critical infrastructure and extend equipment life.",
      icon: "ri-shield-check-line",
      image: "https://readdy.ai/api/search-image?query=Corrosion%20analysis%20laboratory%20with%20Golden%20Black%20logo%2C%20advanced%20testing%20equipment%20for%20metal%20degradation%20assessment%20and%20protection%20strategies&width=500&height=300&seq=corrosion-analysis&orientation=landscape",
      capabilities: [
        "Electrochemical corrosion testing",
        "Metallurgical failure analysis",
        "Corrosion rate monitoring",
        "Inhibitor effectiveness evaluation"
      ]
    },
    {
      title: "Fluid Compatibility Testing",
      description: "Comprehensive testing to ensure chemical compatibility and optimize fluid performance in reservoir conditions.",
      icon: "ri-test-tube-line",
      image: "https://readdy.ai/api/search-image?query=Fluid%20compatibility%20testing%20laboratory%20with%20Golden%20Black%20branding%2C%20advanced%20equipment%20for%20chemical%20interaction%20analysis%20and%20performance%20evaluation&width=500&height=300&seq=fluid-testing&orientation=landscape",
      capabilities: [
        "Chemical compatibility assessment",
        "Thermal stability testing",
        "Emulsion tendency evaluation",
        "Formation damage assessment"
      ]
    },
    {
      title: "Water Quality Analysis",
      description: "Detailed water analysis for production optimization, injection water quality, and environmental compliance.",
      icon: "ri-drop-line",
      image: "https://readdy.ai/api/search-image?query=Water%20quality%20analysis%20laboratory%20with%20Golden%20Black%20logo%2C%20sophisticated%20testing%20equipment%20for%20oilfield%20water%20analysis%20and%20treatment%20optimization&width=500&height=300&seq=water-analysis&orientation=landscape",
      capabilities: [
        "Ion chromatography analysis",
        "Bacterial contamination testing",
        "Scaling tendency prediction",
        "Treatment optimization"
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Advanced Analysis Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our state-of-the-art analytical capabilities provide critical insights for optimizing 
            chemical treatments and solving complex oilfield challenges.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {analysisServices.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src={service.image}
                alt={service.title}
                className="w-full h-48 object-cover"
              />
              
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-xl text-teal-600`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                </div>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="space-y-3">
                  <h4 className="font-semibold text-gray-900">Key Capabilities:</h4>
                  <div className="space-y-2">
                    {service.capabilities.map((capability, capIndex) => (
                      <div key={capIndex} className="flex items-center">
                        <i className="ri-check-line text-teal-600 mr-3"></i>
                        <span className="text-gray-700">{capability}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AnalysisServices;
